<template>
  <section>
    <Title :title-name="pageTitle" :title-link="title.SelectRoom.titleLink" />
    <div class="meal-plan">
      <section class="mt-4">
        <div class="container py-1">
          <div class="my-4">
            <ItemOfVouchers
              icon="meal-plan-voucher"
              color="#f5b945"
              :label="mealPlanLang?.SFS_LANG_ROW_38 || 'Meal Plan voucher'"
            />
          </div>
          <div class="ws-textbox mt-4 py-1" v-html="description"></div>
          <div v-for="(mealPlan, index) in mealPlanList" :key="index">
            <div v-if="checkOldMealPlan(mealPlan)">
              <div v-for="(m, k) in mealPlanInDay" :key="k">
                <div class="meal-plan-box ws-textbox my-4 py-2 ws-textbox__meal-plan">
                  <p>
                    <span>{{ m }}</span> {{ formatDateOldMealPlan(mealPlan.date) }}
                  </p>
                  <div v-if="!checkHaveMealPlan(mealPlan, m)">
                    <span>{{ lang[23].SFS_LANG_ROW_6 }}</span>
                  </div>
                  <div v-else>
                    <div v-if="getTimeOldMealPlan(mealPlan, m) !== ''" class="icon-clock-wrapper">
                      <i class="far fa-clock"></i>
                      <span> {{ getTimeOldMealPlan(mealPlan, m) }}</span>
                    </div>
                    <div class="icon-money-wrapper">
                      <span v-if="checkPrice(mealPlan, m)">
                        {{ getPrice(mealPlan, m) }}
                        {{ mealPlan.currency }}
                        {{ lang[23].SFS_LANG_ROW_7 }}
                      </span>
                      <span v-else>{{ mealPlanLang?.SFS_LANG_ROW_41 || 'Included in hotel' }}</span>
                      <div v-if="PaxsGroup.length > 1">
                        <div v-for="(pax, i) in PaxsGroup" :key="i">
                          <span>{{ pax.first_name }} {{ pax.last_name }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="ws-textbox my-4 py-2 ws-textbox__meal-plan">
                <div
                  class="meal-plan-box"
                  :class="{ 'meal-plan-box--used': mealPlan.is_used, 'meal-plan-box--expired': checkExpired(mealPlan) }"
                  :data-content="mealPlanLang?.SFS_LANG_ROW_51 || 'Used'"
                >
                  <p>
                    <span v-if="mealPlan.type === 1 || mealPlan.type === 6">
                      {{ mealPlanLang?.SFS_LANG_ROW_42 || 'Breakfast' }}
                    </span>
                    <span v-else-if="mealPlan.type === 2">
                      {{ mealPlanLang?.SFS_LANG_ROW_43 || 'Lunch' }}
                    </span>
                    <span v-else-if="mealPlan.type === 3">
                      {{ mealPlanLang?.SFS_LANG_ROW_44 || 'Dinner' }}
                    </span>
                    {{ formatDate(mealPlan.mealplan_time) }}
                  </p>
                  <div v-if="!isBreakfatHrsInclude(mealPlan)" class="icon-clock-wrapper">
                    <i v-if="getTimeMealPlan(mealPlan)" class="far fa-clock"></i>
                    <span> {{ getTimeMealPlan(mealPlan) }}</span>
                  </div>
                  <div class="icon-money-wrapper">
                    <i v-if="Number(mealPlan.valamount.replace('.00', ''))" class="fas fa-money-bill-wave"></i>
                    <span v-if="Number(mealPlan.valamount.replace('.00', ''))">
                      {{ mealPlan.valamount.replace('.00', '') }}
                      {{ mealPlan.currency }}
                      {{ mealPlan.is_used ? mealPlanLang?.SFS_LANG_ROW_46 || 'claimed' : '' }}
                    </span>
                    <span v-else>{{ mealPlanLang?.SFS_LANG_ROW_41 || 'Included in hotel' }}</span>
                  </div>
                  <div v-if="Number(mealPlan.valamount.replace('.00', '')) !== 0 && !checkExpired(mealPlan)">
                    <router-link
                      :to="{
                        name: 'MealPlanPhotoPay',
                        query: {
                          secret: secret,
                          voucher_code: mealPlan.voucher_code,
                          mealplan_time: mealPlan.mealplan_expired,
                          is_used: mealPlan.is_used
                        }
                      }"
                    >
                      <a class="click-here" style="cursor: pointer">{{
                        !mealPlan.is_used
                          ? mealPlanLang?.SFS_LANG_ROW_40 || 'Click here to scan your receipt'
                          : mealPlanLang?.SFS_LANG_ROW_50 || 'Click here to check the status'
                      }}</a>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import ItemOfVouchers from '@/components/ItemOfVouchers/index'
import Title from '@/components/Title/index'
import { mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
import { empty } from '@/utils/helper'

export default {
  name: 'MealPlanPage',
  components: { Title, ItemOfVouchers },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      breakfast: 'Breakfast',
      lunch: 'Lunch',
      dinner: 'Dinner',
      mealPlanInDay: ['Breakfast', 'Lunch', 'Dinner'],
      mealPlanList: []
    }
  },
  computed: {
    ...mapGetters({
      flight: 'Flight/Flight',
      listMealPlanInfo: 'MealPlan/listMealPlanInfos'
    }),
    pageTitle() {
      const { lang } = this
      return lang?.hotel_mobile_new?.SFS_LANG_ROW_28 || 'Home'
    },
    description() {
      if (empty(this.mealPlanList) || empty(this.mealPlanLang)) {
        return
      }

      // Old Meal Plan
      if (JSON.parse(this.mealPlanList[0]?.params) && JSON.parse(this.mealPlanList[0].params)?.is_use_old_meal_plan) {
        let mealPlanDesc =
          (this.mealPlanLang?.SFS_LANG_ROW_49 || 'With your hotel booking you receive the following meals.') + ': '

        // More night for meal plan
        if (this.mealPlanList.length > 1) {
          const mealPlanDecsItems = this.mealPlanList.map(
            (item) => `<br/>${this.formatDateOldMealPlan(item.date, 'DD-MMM-YYYY')}: ${item.mealplan_desc}`
          )
          mealPlanDesc += mealPlanDecsItems.join('')

          return mealPlanDesc.replace('.:', ':')
        }

        // One night for meal plan
        mealPlanDesc += this.mealPlanList[0].mealplan_desc
        return mealPlanDesc.replace('.:', ':')
      }

      // New Meal Plan
      return (
        this.mealPlanLang?.SFS_LANG_ROW_39 ||
        'With your hotel booking you receive the following meals. These are included in the hotel booking or you can claim it back with the receipt.'
      )
    },
    mealPlanLang() {
      const { lang } = this
      return lang['meal_plan_photo_claim_new'] || {}
    }
  },
  watch: {
    listMealPlanInfo() {
      this.mealPlanList = this.listMealPlanInfo
    }
  },
  mounted() {
    this.$store.dispatch('MealPlan/resetMealPlanInfo')
    this.$store.dispatch('Flight/getFlight')
    this.$store.dispatch('MealPlan/getMealPlanReceiptInfo', {
      secret: this.secret
    })
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      return moment(date).format('DD MMM YYYY')
    },
    getTimeMealPlan(meal_plan) {
      let during_time = ''
      if (meal_plan.valamount == 0) {
        let temp_during_time = JSON.parse(meal_plan.during_time)
        if (!temp_during_time || (!temp_during_time.from && !temp_during_time.to)) {
          return
        }
        during_time = `${temp_during_time.from} ${this.mealPlanLang?.SFS_LANG_ROW_47 || 'till'} ${temp_during_time.to}`
      } else {
        if (!meal_plan.mealplan_expired) return
        const mealplan_time = moment(meal_plan.mealplan_expired).format('HH:mm MMM DD YYYY')
        during_time = `${this.mealPlanLang?.SFS_LANG_ROW_45 || 'Expire time:'} ${mealplan_time}`

        if (meal_plan.airport_name) {
          during_time += ` ${this.mealPlanLang?.SFS_LANG_ROW_48 || 'by'} ${meal_plan.airport_name}`
        }
      }

      return during_time
    },
    isBreakfatHrsInclude(meal_plan) {
      if (parseFloat(meal_plan.valamount) == 0 && meal_plan.isHrs) {
        return true
      }
      return false
    },
    formatDateOldMealPlan(date, format = 'DD MMM YYYY') {
      if (!date) return ''
      return moment(date).format(format)
    },
    getTimeOldMealPlan(mealPlanData, mealPlan) {
      // Date in js   with sunday return 0, monday return 1
      // Date in data with sunday return 6, monday return 0
      const date = new Date(mealPlanData.date)
      const day = date.getDay() > 0 ? date.getDay() - 1 : 6
      var infoTime
      if (mealPlan == this.breakfast) {
        infoTime = mealPlanData.breakfast_operating_time
      } else if (mealPlan == this.lunch) {
        infoTime = mealPlanData.lunch_operating_time
      } else if (mealPlan == this.dinner) {
        infoTime = mealPlanData.dinner_operating_time
      }
      if (infoTime === '' || infoTime == null) {
        return ''
      }
      const time = JSON.parse(infoTime)[day].data
      if (time.operating_opentime == null && time.operating_closetime == null) {
        return ''
      }
      return time.operating_opentime + ' till ' + time.operating_closetime
    },
    checkHaveMealPlan(data, m) {
      if (m == this.breakfast) {
        return data.breakfast
      } else if (m == this.lunch) {
        return data.lunch
      } else if (m == this.dinner) {
        return data.mealplan
      }
      return false
    },
    checkPrice(data, m) {
      let price = 0
      if (m == this.breakfast) {
        price = data.breakfast_price
      } else if (m == this.lunch) {
        price = data.lunch_price
      } else if (m == this.dinner) {
        price = data.dinner_price
      }
      return Number(this.formatPrice(price))
    },
    getPrice(data, m) {
      let price = 0
      if (m == this.breakfast) {
        price = data.breakfast_price
      } else if (m == this.lunch) {
        price = data.lunch_price
      } else if (m == this.dinner) {
        price = data.dinner_price
      }
      return this.formatPrice(price)
    },
    formatPrice(price) {
      return price.toString().replace('.00', '')
    },
    checkOldMealPlan(mealPlan) {
      if (mealPlan.params) {
        return JSON.parse(this.mealPlanList[0].params).is_use_old_meal_plan ?? false
      }
      return false
    },
    checkExpired(meal) {
      if (!meal) {
        return true
      }

      const expired = new Date(meal.mealplan_expired)
      const airportTime = new Date(meal.currentTime)
      if (meal.is_used || parseFloat(meal.valamount) == 0) {
        return false
      }

      return airportTime.getTime() > expired.getTime() ? true : false
    }
  }
}
</script>

<style lang="scss" scoped>
$colorBlue: #37c5e7;
.meal-plan {
  .ws-textbox__meal-plan {
    position: relative;
    .meal-plan-box--used::after {
      position: absolute;
      content: attr(data-content);
      top: 0;
      right: 0;
      width: 60px;
      height: 32px;
      background-color: $colorBlue;
      color: white;
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: var(--meal-plan-box-border-radius);
    }
    .meal-plan-box--expired::after {
      position: absolute;
      content: 'Expired';
      top: 0;
      right: 0;
      width: 60px;
      height: 32px;
      background-color: orange;
      color: white;
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: var(--meal-plan-box-border-radius);
    }
  }
  .icon-clock-wrapper i {
    font-size: 20px;
    color: $colorBlue;
  }

  .icon-money-wrapper i {
    font-size: 16px;
    color: #ffb200;
  }

  .click-here {
    font-size: 14px;
    color: #414141;
    text-decoration: underline;
  }
}
.pl-20 {
  padding-left: 22px;
}
body:dir(rtl) {
  .meal-plan {
    .meal-plan-box--expired::after,.meal-plan-box--used::after {
      right: auto;
      left: 0;
    }
  }
}
</style>
